module.exports = __webpack_public_path__ + "img/wrench.be5030ca.webp";